// Removes keys with a nullish value from an object
export default function deleteNil<T extends Record<string, unknown>>(
  object: Partial<T>
): { [K in keyof T]?: NonNullable<T[K]> } {
  return Object.entries(object).reduce(
    (result, [key, value]) => {
      if (value != null) {
        (result as Record<string, unknown>)[key] = value;
      }
      return result;
    },
    {} as { [K in keyof T]?: NonNullable<T[K]> }
  );
}
